import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {IonButton, IonIcon, IonInput, useIonViewWillEnter} from '@ionic/react';
import { currencyFormatBig } from '../../utils/currency';
import './CardValueSelect.css';
import {uiInputMode} from "../../utils/ui";

const VALUE_BUTTONS = [3, 10, 30];

type CardValueSelectProps = {
  selectedValue: number;
  minimum: number;
  maximum: number;
  currentCardValue: number;
  setSelectedValue: (v: number) => void;
};

export default function CardValueSelect({
  selectedValue,
  minimum,
  maximum,
  currentCardValue,
  setSelectedValue,
}: CardValueSelectProps) {
  const [t] = useTranslation('global');

  const [isCustom, setIsCustom] = useState<boolean>(false);

  useEffect(() => {
    setIsCustom(selectedValue > 0 && !VALUE_BUTTONS.includes(selectedValue));
  }, []);

  const clickField = () => {
    if (!isCustom) {
      setSelectedValue(0);
      setIsCustom(true);
    }
  };

  const useButton = (v: number) => {
    setIsCustom(false);
    setSelectedValue(v);
  };

  const setValue = (v: string) => {
    setIsCustom(true);
    const nv = parseInt(v);
    if (nv) {
      setSelectedValue(nv);
    } else {
      setSelectedValue(0);
    }
  };

  let customValue = '';
  if (isCustom) {
    if (selectedValue != 0) {
      customValue = '' + selectedValue;
    }
  }

  return (
    <>
      <p className="pt-4 instructions ion-text-center">
        {t('cardvalue.instruction')}
      </p>
      <div className="pt-1 cardvalue-select-buttons">
        {VALUE_BUTTONS.map((v) => (
          <IonButton key={v}
            onClick={() => useButton(v)}
            className={
              'btn-default ' + (selectedValue != v ? 'btn-disabled' : '')
            }
            expand="block"
            color="dark"
            fill="outline"
          >
            {currencyFormatBig(v)}
          </IonButton>
        ))}
      </div>
      <div className="cardvalue-select-custom pb-2">
        <div>
          <p className="instructions">{t('cardvalue.custominstruction')}</p>
          <p className="instructions">
            <small>{t('cardvalue.custommin', { min: minimum })}</small>
          </p>
        </div>
        <IonInput
          value={customValue}
          className={'cardvalue-custominput ' + (customValue ? 'active' : '')}
          fill="outline"
          mode={uiInputMode()}
          aria-label={t('cardvalue.customamount')!}
          onClick={() => clickField()}
          onIonInput={(e) => setValue(e.detail.value!)}
          type="text"
          label="$"
          labelPlacement="start"
        ></IonInput>
      </div>
      <p
        className={
          'instructions ion-text-center cardvalue-select-warn ' +
          (selectedValue + currentCardValue > maximum ? 'error' : '')
        }
      >
        <IonIcon
          className="cardvalue-exclamation-circle"
          src={
            selectedValue > maximum
              ? 'assets/icon/exclamation-circle-danger.svg'
              : 'assets/icon/exclamation-circle.svg'
          }
        ></IonIcon>
        <span>{t('cardvalue.custommax', { v: maximum })}</span>
      </p>
    </>
  );
}
